import React from "react";
import Skeleton from "react-loading-skeleton";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export const SkeletonTable = ({ columns }) => {
  const StyledTable = styled(Table)(({ theme }) => ({
    padding: 2, // Adjust padding as needed
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--qv-bg-253338, #253338)",
      color: theme.palette.common.white,
      fontFamily: "CircularSTDMedium !important",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      fontFamily: "CircularSTDBook !important",
    },
    [`&.${tableCellClasses.table}`]: {
      fontSize: 14,
      fontFamily: "CircularSTDBook !important",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
    "& td, & th": {
    border: "none",
  },
  }));

  return (
    <>
      <TableContainer>
        <StyledTable sx={{ minWidth: 500 }} aria-label="customized table">
          <TableHead>
            <StyledTableRow>
            {columns.map((col, index) => (
              <StyledTableCell key={index}>{col}</StyledTableCell>
            ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((row) => (
              <StyledTableRow key={row}>
                {columns.map((col, index) => (
                  <StyledTableCell key={index}>
                    <Skeleton />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </>
  );
};
